import { Box, Stack, Input, Textarea, Button, Heading, Text, Avatar, Flex, Card, CardHeader, CardBody, Icon, Select } from '@chakra-ui/react';
import { FaUser } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2';
import React, { useState ,useEffect } from 'react';
import ReactSelect from 'react-select';
import { useRefreshContext } from '../../utils/context/refreshContext';

function MyProfile({ initialFullName, initialEmail, initialRole }) {
  const { triggerRefresh } = useRefreshContext();
  const [isEditable, setIsEditable] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState('');
  const [profileData, setProfileData] = React.useState({
    profile_image_url:'',
    avatarSrc: '',
    FullName: initialFullName,
    userName: '',
    registerNumber: '',
    password: '',
    email: initialEmail,
    contact_no: '',
    gender: '',
    bio: '',
    address: {
      street: '',
      city: '',
      state: '',
      country: {
        iso2: '', 
        name: ''
      },
      pinCode: {
        postalCode: '',
        isValid: false,
        region: ''
      },
      contact_address: ''
    },
    experience: '',
    skills: '',
    services: '',
    role: initialRole,
    country_code: '',
    individual_identity: '',
    agencyDetails: {
      licenseId: '',
      certification: '',
      certificationExpiry: '',
      issuingAuthority: ''
    },
    organizational_specialization: '',
    organization_type: '',
    experience: '',
    proffession: '',
    skills: '',
    services: ''
  });

  const [countries, setCountries] = useState([]);

  const fetchCountriesData = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/globalrouter/get-countries`);

        console.log('Response data countries:', response.data.data); 
        
        const countriesOptions = response.data.data.map(country => ({
          label: country.name,
          value: country.iso2
        }));
        setCountries(countriesOptions);
        console.log('Countries:', countriesOptions);

      
      
    } catch (error) {
        console.error('Error fetching countries data:', error);
    }
    
  };
  const handleCountryChange = (selectedOption) => {
    setProfileData({
      ...profileData,
      address: {
        ...profileData.address,
        country: {
          iso2: selectedOption.value,
          name: selectedOption.label
        }
      }
    });
   
  };

  const handlePinCodeChange = async (e) => {
    const pinCode = e.target.value;
    
    setProfileData({
      ...profileData,
      address: {
        ...profileData.address,
        pinCode: {
          ...profileData.address.pinCode,
          postalCode: pinCode
        }
      }
    });
    
    if (pinCode.trim()) {
      try {
        const country = profileData.address.country.name;
        
        if (country === 'United Kingdom') {
          const response = await axios.get(`https://api.postcodes.io/postcodes/${pinCode}`);
          
          if (response.status === 200 && response.data && response.data.result) {
            const regionValue = response.data.result.region || 'Region not found';
            const cityValue = response.data.result.admin_district || response.data.result.parish || '';
            
            setProfileData(prevData => ({
              ...prevData,
              address: {
                ...prevData.address,
                pinCode: {
                  ...prevData.address.pinCode,
                  postalCode: pinCode,
                  region: regionValue,
                  isValid: true
                },
                city: cityValue
              }
            }));
          }
        } else if (country === 'India') {
          const response = await axios.get(`https://api.postalpincode.in/pincode/${pinCode}`);
          
          if (response.status === 200 && response.data && response.data[0].Status === "Success") {
            const postOffice = response.data[0].PostOffice[0];
            const regionValue = `${postOffice.District}, ${postOffice.State}`;
            const cityValue = postOffice.District || postOffice.Block || postOffice.Name;
            
            setProfileData(prevData => ({
              ...prevData,
              address: {
                ...prevData.address,
                pinCode: {
                  ...prevData.address.pinCode,
                  postalCode: pinCode,
                  region: regionValue,
                  isValid: true
                },
                city: cityValue
              }
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching region from pin code:", error);
        setProfileData(prevData => ({
          ...prevData,
          address: {
            ...prevData.address,
            pinCode: {
              ...prevData.address.pinCode,
              postalCode: pinCode,
              isValid: false
            }
          }
        }));
      }
    }
  };

  React.useEffect(() => {
    const fetchProfileData = async () => {
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
          console.error('No ticket token found in sessionStorage');
          return;
      }
      // console.log('Ticket Token:', ticketToken);
  
      try {
          const response = await axios.get(
              `${process.env.REACT_APP_SERVER_URL}/applicant/get-applicant-details`,
              {
                  headers: {
                      Authorization: `Bearer ${ticketToken}`
                  }
              }
          );
  
          console.log('Response data:', response.data);
  
          console.log('Profile Image URL:', response.data.data.profile_image_url);
              setProfileData({
                  profile_image_url: response.data.data.profile_image_url || '',
                  FullName: response.data.data.FullName || '',
                  registerNumber: response.data.data.registerNumber || '',
                  userName: response.data.data.userName || '',
                  email: response.data.data.email || '',
                  role: response.data.data.role || '',
                  country_code: response.data.data.country_code || '',
                  address: {
                      street: response.data.data.address?.street || '',
                      city: response.data.data.address?.city || '',
                      state: response.data.data.address?.state || '',
                      contact_address: response.data.data.address?.contact_address || '',
                      country: {
                        iso2: response.data.data.address?.country.iso2 || '',
                        name: response.data.data.address?.country.name || ''
                      },
                      pinCode: {
                        postalCode: response.data.data.address?.pinCode.postalCode || '',
                        isValid: response.data.data.address?.pinCode.isValid || null,
                        region: response.data.data.address?.pinCode.region || ''
                      }
                  },
                  individual_identity: response.data.data.individual_identity || '',
                  agencyDetails: {
                      licenseId: response.data.data.agencyDetails?.licenseId || '',
                      certification: response.data.data.agencyDetails?.certification || '',
                      certificationExpiry: response.data.data.agencyDetails?.certificationExpiry || '',
                      issuingAuthority: response.data.data.agencyDetails?.issuingAuthority || ''
                  },
                  organization_type: response.data.data.organization_type || '',
                  organizational_specialization: response.data.data.organizational_specialization || '',
                  bio: response.data.data.bio || '',
                  contact_no: response.data.data.contact_no || '',
                  gender: response.data.data.gender || '',
                  experience: response.data.data.experience || '',
                  proffession: response.data.data.proffession || '',
                  skills: response.data.data.skills || '',
                  services: response.data.data.services || ''
              });
        
      } catch (error) {
          console.error('Error fetching profile data:', error);
      }
      console.log(profileData.role);
  };

    fetchProfileData();
    console.log("valid : ",profileData.address.pinCode.isValid);
    
  }, []);

  const submitSeekerDetails = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
  
    const formData = new FormData(event.target);
    const tempData = {};
    tempData.profile_image_url = profileData.profile_image_url;
    // Explicitly map form data to tempData object
    tempData.FullName = formData.get('FullName') || profileData.FullName;
    tempData.userName = formData.get('userName') || profileData.userName;
    tempData.registerNumber = formData.get('registerNumber') || profileData.registerNumber;
    tempData.password = formData.get('password') || profileData.password;
    tempData.email = formData.get('email') || profileData.email;
    tempData.contact_no = formData.get('contact_no') || profileData.contact_no;
    tempData.gender = formData.get('gender') || profileData.gender;
    tempData.role = formData.get('role') || profileData.role;
    tempData.country_code = formData.get('country_code') || profileData.country_code;
    tempData.individual_identity = formData.get('individual_identity') || profileData.individual_identity;
    tempData.bio = formData.get('bio') || profileData.bio;
    tempData.experience = formData.get('experience') || profileData.experience;
    tempData.skills = formData.get('skills') || profileData.skills;
    tempData.services = formData.get('services') || profileData.services;
  
    // Address details
    tempData.address = {
      street: formData.get('address.street') || profileData.address.street,
      city: formData.get('address.city') || profileData.address.city,
      state: formData.get('address.state') || profileData.address.state,
      contact_address: formData.get('address.contact_address') || profileData.address.contact_address,
      country: {
        iso2: formData.get('address.country.iso2') || profileData.address.country.iso2,
        name: formData.get('address.country.name') || profileData.address.country.name
      },
      pinCode: {
        postalCode: formData.get('address.pinCode.postalCode') || profileData.address.pinCode.postalCode
      }
    };
  
    // Agency details
    tempData.agencyDetails = {
      licenseId: formData.get('agencyDetails.licenseId') || profileData.agencyDetails.licenseId,
      certification: formData.get('agencyDetails.certification') || profileData.agencyDetails.certification,
      certificationExpiry: formData.get('agencyDetails.certificationExpiry') || profileData.agencyDetails.certificationExpiry,
      issuingAuthority: formData.get('agencyDetails.issuingAuthority') || profileData.agencyDetails.issuingAuthority
    };
  
    // Organizational details
    tempData.organization_type = formData.get('organization_type') || profileData.organization_type;
    tempData.organizational_specialization = formData.get('organizational_specialization') || profileData.organizational_specialization;
  
    const ticketToken = sessionStorage.getItem('ticketToken');
    if (!ticketToken) {
      console.error('No ticket token found in sessionStorage');
      return;
    }
    console.log('Ticket Token:', ticketToken);
    console.log('tempData: ', tempData);
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/applicant/update-applicant-details`,
        tempData,
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`
          }
        }
      );
      console.log('Response data: submit ? ', response.data); // Log the response data
      if (response.data.success) {
        triggerRefresh();
        Swal.fire({
          icon: 'success',
          title: 'Profile Updated!',
          text: 'Your profile has been updated successfully.',
          showConfirmButton: false,
          timer: 2000, // Automatically close after 2 seconds
          width: '300px',
          padding: '1em',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });
  
        setIsEditable(false);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: 'Profile update failed. Please try again.',
          footer: '<a href="#">Why do I have this issue?</a>',
          width: '300px',
          padding: '1em',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });
      }
  
      // Optionally update the profile data after submission
      setProfileData({
        ...profileData, // Keep existing data
        // You can update any specific fields if needed
      });
    } catch (error) {
      console.error('Error submitting profile data:', error); // Updated error message
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'There was an error submitting your profile data. Please try again later.',
        footer: `<a href="#">Why do I have this issue?</a>`, // Optional: Add a footer link for more info
        width: '300px', // Adjust the width to make it smaller
        padding: '1em', // Adjust padding for a more compact look
        showClass: {
          popup: 'animate__animated animate__fadeInDown' // Optional: Add animation for entry
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp' // Optional: Add animation for exit
        }
      });
    }
  };

  const handleEditClick = () => {
    setIsEditable(true);
    fetchCountriesData();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      uploadProfileImage(file);
    }
  };

  const uploadProfileImage = async (file) => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    if (!ticketToken) {
      console.error('No ticket token found in sessionStorage');
      return;
    }

    const formData = new FormData();
    formData.append('profileImage', file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/applicant/upload-profile-image`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (response.data.message === "Profile image uploaded successfully") {
        Swal.fire({
          icon: 'success',
          title: 'Image Uploaded!',
          text: 'Your profile image has been uploaded successfully.',
          showConfirmButton: false,
          timer: 2000,
          width: '300px',
          padding: '1em',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });

        setProfileData((prevData) => ({
          ...prevData,
          profile_image_url: response.data.fileUrl
        }));
      }
    } catch (error) {
      console.error('Error uploading profile image:', error);
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: 'There was an error uploading your profile image. Please try again later.',
        footer: '<a href="#">Why do I have this issue?</a>',
        width: '300px',
        padding: '1em',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
    }
  };

  return (
    <Box flex="1" p={4} overflowY="auto" width="100%" maxW="100%" mx="auto" borderRadius="md" boxShadow="lg">
      <form onSubmit={submitSeekerDetails}>
        <Flex justifyContent="space-between" alignItems="center" mb={4}>
          <Heading fontSize={["lg", "xl"]} textAlign="left">Profile</Heading>
          {/* <Box position="absolute" right="0" zIndex="1"> */}
          <Box>
            <Button colorScheme="teal" size="sm" mr={2} onClick={handleEditClick} >Edit</Button>
            <Button colorScheme="blue" size="sm" type="submit" disabled={!isEditable} >Submit</Button>
          </Box>
        </Flex>
        <Text mb={4} fontSize={["xs", "sm"]} textAlign="left">
          This is how others will see you on the site.
        </Text>

        {(!profileData.role || profileData.role.trim() === '') ? (
          <Stack spacing={3}>
            <Box>
              <Text fontWeight="bold" textAlign="left">User Name</Text>
              <Input name="userName" defaultValue={profileData.userName} isReadOnly={!isEditable} />
            </Box>
            <Box>
              <Text fontWeight="bold" textAlign="left">Email</Text>
              <Input name="email" placeholder="Email" defaultValue={profileData.email} isReadOnly={!isEditable} />
            </Box>
          </Stack>
        ) : (
          <>
            <Flex alignItems="center" mb={4}>
              <Avatar 
                size="2xl" 
                src={selectedImage || profileData.profile_image_url} 
                icon={<Icon as={FaUser} />} 
                mr={4} 
              />
              {isEditable && (
                <Box>
                  <Input type="file" name="avatar" accept="image/*" onChange={handleImageChange} width="100px"
                   size="xs"
                   borderRadius="md"
                   p={1}/>
                </Box>
              )}
            </Flex>

            <Card mb={6} boxShadow="2xl" borderRadius="md">
              <CardHeader>
                <Heading fontSize="md" textAlign="left">
                  {profileData.role === 'individual_applicant' ? 'Personal Information' : 'Organizational Information'}
                </Heading>
              </CardHeader>
              <CardBody>
                <Stack spacing={3}>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">
                      {profileData.role === 'individual_applicant' ? 'Name' : 'Organization Name'}
                    </Text>
                    <Input name="FullName" defaultValue={profileData.FullName} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">
                      Register Number
                    </Text>
                    <Input name="registerNumber" defaultValue={profileData.registerNumber} isReadOnly={true} />
                  </Box>
                  
                  <Box>
                    <Text fontWeight="bold" textAlign="left">
                      {profileData.role === 'individual_applicant' ? 'Identity Number' : 'License ID'}
                    </Text>
                    {profileData.role === 'individual_applicant' ? (
                      <Input name="individual_identity" defaultValue={profileData.individual_identity} isReadOnly={!isEditable} />
                    ) : (
                      <Input name="licenseId" defaultValue={profileData.agencyDetails.licenseId} isReadOnly={!isEditable} />
                    )}
                  </Box>
                
                  <Box>
                    <Text fontWeight="bold" textAlign="left">User Name</Text>
                    <Input name="userName" defaultValue={profileData.userName} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Password</Text>
                    <Input name="password" placeholder="Password" type="password" defaultValue={profileData.password} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Email</Text>
                    <Input name="email" placeholder="Email" defaultValue={profileData.email} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Contact Number</Text>
                    <Input name="contact_no" defaultValue={profileData.contact_no} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Gender</Text>
                    <Select
                      name="gender"
                      value={profileData.gender}
                      isDisabled={!isEditable}
                      onChange={(e) => setProfileData({ ...profileData, gender: e.target.value })}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Rather not say</option>
                    </Select>
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Role</Text>
                    <Input name="role" defaultValue={profileData.role} isReadOnly={true} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Country Code</Text>
                    <Input name="country_code" defaultValue={profileData.country_code} isReadOnly={!isEditable} />
                  </Box>
                </Stack>
              </CardBody>
            </Card>

            <Card mb={6} boxShadow="2xl" borderRadius="md">
              <CardHeader>
                <Heading fontSize="md" textAlign="left">Address Information</Heading>
              </CardHeader>
              <CardBody>
                <Stack spacing={3}>
                <Box textAlign="left">
                    
                    <Text fontWeight="bold" textAlign="left">Country</Text>
                    <ReactSelect
                      id="address.country"
                      
                      placeholder={profileData.address.country.name ? profileData.address.country.name : "Select country"}
                      value={{ value: profileData.address.country.iso2, label: profileData.address.country.name }}
                      onChange={handleCountryChange}
                      options={countries}
                      isDisabled={!isEditable}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          borderColor: state.isFocused ? 'blue.500' : 'gray.50',
                          '&:hover': { borderColor: 'gray.400' },
                        }),
                      }}
                    />
                 
                  </Box>

                  <Box>
                    <Text fontWeight="bold" textAlign="left">Address</Text>
                    <Textarea name="address.contact_address" defaultValue={profileData.address.contact_address} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Pin Code</Text>
                    <Input 
                      name="address.pinCode.postalCode" 
                      defaultValue={profileData.address.pinCode.postalCode} 
                      isReadOnly={!isEditable} 
                      onChange={handlePinCodeChange}
                    />
                    {profileData.address.pinCode.isValid && (
                      <Text fontSize="xs" color="green.500" textAlign="left">
                        Region: {profileData.address.pinCode.region}
                      </Text>
                    )}
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">District/City</Text>
                    <Input 
                      name="address.city" 
                      value={profileData.address.city} 
                      onChange={(e) => setProfileData({
                        ...profileData,
                        address: {
                          ...profileData.address,
                          city: e.target.value
                        }
                      })}
                      isReadOnly={!isEditable} 
                    />
                  </Box>
                </Stack>
              </CardBody>
            </Card>

            <Card mb={6} boxShadow="2xl" borderRadius="md">
              <CardHeader>
                <Heading fontSize="md" textAlign="left">Additional Information</Heading>
              </CardHeader>
              <CardBody>
                <Stack spacing={3}>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Bio</Text>
                    <Textarea name="bio" placeholder="Bio" defaultValue={profileData.bio} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Experience</Text>
                    <Input name="experience" placeholder="Experience" defaultValue={profileData.experience} isReadOnly={!isEditable} />
                  </Box>
                  {/* <Box>
                    <Text fontWeight="bold" textAlign="left">Skills</Text>
                    <Textarea name="skills" placeholder="Skills" defaultValue={profileData.skills} isReadOnly={!isEditable} />
                  </Box> */}
                </Stack>
              </CardBody>
            </Card>

            {profileData.role !== 'individual_applicant' && (
              <>
                <Card mb={6} boxShadow="2xl" borderRadius="md">
                  <CardHeader>
                    <Heading fontSize="md" textAlign="left">Agency Details</Heading>
                  </CardHeader>
                  <CardBody>
                    <Stack spacing={3}>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Agency License ID</Text>
                        <Input name="agencyDetails.licenseId" defaultValue={profileData.agencyDetails.licenseId} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Certification</Text>
                        <Input name="agencyDetails.certification" defaultValue={profileData.agencyDetails.certification} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Certification Expiry</Text>
                        <Input name="agencyDetails.certificationExpiry" type="date" defaultValue={profileData.agencyDetails.certificationExpiry} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Issuing Authority</Text>
                        <Input name="agencyDetails.issuingAuthority" defaultValue={profileData.agencyDetails.issuingAuthority} isReadOnly={!isEditable} />
                      </Box>
                    </Stack>
                  </CardBody>
                </Card>

                <Card mb={6} boxShadow="2xl" borderRadius="md">
                  <CardHeader>
                    <Heading fontSize="md" textAlign="left">Specialties and Services</Heading>
                  </CardHeader>
                  <CardBody>
                    <Stack spacing={3}>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Services</Text>
                        <Textarea name="services" placeholder="Services" defaultValue={profileData.services} isReadOnly={!isEditable} />
                      </Box>
                    </Stack>
                  </CardBody>
                </Card>

                <Card mb={6} boxShadow="2xl" borderRadius="md">
                  <CardHeader>
                    <Heading fontSize="md" textAlign="left">Organizational Details</Heading>
                  </CardHeader>
                  <CardBody>
                    <Stack spacing={3}>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Organization Type</Text>
                        <Input name="organization_type" placeholder="Organization Type" defaultValue={profileData.organization_type} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Organizational Specialization</Text>
                        <Input name="organizational_specialization" defaultValue={profileData.organizational_specialization} isReadOnly={!isEditable} />
                      </Box>
                    </Stack>
                  </CardBody>
                </Card>
              </>
            )}
          </>
        )}
      </form>
    </Box>
  );
}

export default MyProfile;